import './js/vendors/orejime';
import './style.css';
import { createApp } from 'vue';
import ResponsiveMenu from '@/vue/ResponsiveMenu.vue';
import NewsletterSubscriptionForm from '@/vue/NewsletterSubscriptionForm.vue';
import AnimatedFigure from '@/vue/AnimatedFigure.vue';
import MapboxMap from '@/vue/MapboxMap.vue';
import Carrousel from '@/vue/Carrousel.vue';

// App main
const header = async () => {
    // Create our vue instance
    const app = createApp({
        name: 'Header',
        components: {
            ResponsiveMenu,
        },
    });

    // Mount the app
    return app.mount('#header');
};

// Execute async function
header().then(() => {});

const cmsBlocks = async () => {
    const app = createApp({
        name: 'CmsBlocks',
        components: {
            NewsletterSubscriptionForm,
            AnimatedFigure,
            MapboxMap,
            Carrousel,
        },
    });
    return app.mount('#main');
};

cmsBlocks().then(() => {});

// Accept HMR as per: https://vitejs.dev/guide/api-hmr.html
if (import.meta.hot) {
    import.meta.hot.accept();
}
